/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 */

(function () {
	
	$(document).ready(function () {
		
		// global init
		var linkformContainer = $('#linkformContainer');
		var linkForm = new LinkFormController(linkformContainer);

	});

})();
